<template>
  <div class="new-grid">
    <div v-if="!loaded" style="padding-top: 100vh"></div>

    <main
      v-if="loaded"
      class="grid-contentpage activitypage"
      :class="themeClass"
    >
      <ContentArea
        :model="model.Content"
        :pageType="'ActivityCollection'"
        @ready="$_removePageLoader()"
        :category="category"
      />
    </main>
  </div>
</template>

<script>
import Api from '@/Scripts/api/api';
import pageLoader from '@/Scripts/lib/helper/pageLoader.js';
import UrlHelper from '@/Scripts/lib/helper/urlHelper.js';
import themeHelper from '@/Scripts/lib/helper/themeHelper.js';
const ContentArea = () => import(/* webpackChunkName: "ContentArea" */ '@/Scripts/components/shared/ContentArea/ContentArea.vue');

export default {
  name: 'ActivityCollectionPage',
  mixins: [themeHelper, pageLoader],
  components: {
    ContentArea
  },
  data () {
    return {
      model: {},
      loaded: false
    };
  },
  computed: {
    category () {
      let val = '';
      if (this.model.CatalogName && this.model.CatalogName.length > 0) {
        val = this.model.CatalogName.split(' ').pop().toLowerCase();
      }
      return val;
    },
    themeClass () {
      if (typeof this.themeName !== 'undefined') {
        if (this.themeName === 'black') {
          return '-black-theme';
        }
      }
      return '';
    }
  },
  methods: {
    blockStyle (block) {
      if (typeof block.ColorOptions !== 'undefined') {
        return {
          backgroundColor: block.ColorOptions.BackgroundColor,
          color: block.ColorOptions.FontColor
        };
      }
      return {};
    }
  },
  created () {
    Api.getContentByFriendlyUrl(UrlHelper.getCurrentUrlWithAction('json')).then(
      response => {
        this.model = response.data;
        this.initPageTheme(this.model);
        // pass cataloglink to productrow
        if (this.model.Content) {
          const blocks = this.model.Content.filter(obj => obj.__type__ === 'ProductRowBlock' || obj.__type__ === 'VideoHeroBlock');
          blocks.forEach((block) => {
            block.ViewMoreDestination = this.model.CatalogLink;
            block.ViewMoreLink = this.insertString('Global', 'ViewMore');
          });
        }
        this.loaded = true;
      }
    );
  }
};
</script>

<style lang="scss" src="@/scss/objects/objects.grid-contentpage.scss"></style>

<style lang="scss">
.activitypage {
  padding-bottom: 0;

  .highlight-block {
    padding-bottom: 0 !important;
  }
}
</style>
